import React from 'react';

export const SelectInput = (props) => (
	<label className={props.labelClassName} htmlFor={props.name}>
		<span className="label">
			{props.label}
			{props.required ? ('*') : (false)}
		</span>
		<div className="hint" dangerouslySetInnerHTML={{__html: props.hint}} />
		<select
			defaultValue={props.defaultValue}
			className={props.className} 
			id={props.id} 
			name={props.name} 
			onChange={props.onChange} 
			value={props.value} 
			disabled={props.disabled}>
				<option
					value=""> 
					Select an option
				</option>
			{props.options.map(option => (
				<option 
					key={option.value}
					value={option.value}
					data={option.data}>
						{option.label}
				</option>	
			))}
		</select>
		<span className="form-error">
			<p>{props.errMessage}</p>
		</span>
	</label>
);


// WEBPACK FOOTER //
// ./src/components/BasicForm/SelectInput.js